// @ts-check
"use strict"

const axios = require("axios")
const { ConfigService, RunConfigService } = require("@nuskin/ns-util")

const PRODUCT_RECOMMENDATIONS_PATH = "/product-recommendation/v1/recommendations"

const getRecommendations = async (options) => {
    const runCfg = RunConfigService.getRunConfig()

    const DEFAULT_OPTIONS = {
        country: runCfg.country,
        locale: runCfg.language + "_" + runCfg.country
    }
    options = Object.assign({}, DEFAULT_OPTIONS, options)

    const baseUrl = ConfigService.getMarketConfig().awsUrl

    try {
        if (!baseUrl) throw new Error("Invalid AWS base URL")

        const params = { locale: options.locale, market: options.country }

        if (options.productSkus) params.cartSkus = options.productSkus.toString()

        const response = await axios.default.get(baseUrl + PRODUCT_RECOMMENDATIONS_PATH, { params })

        return response.data
    } catch (e) {
        console.error(e)
        return []
    }
}

module.exports = {
    getRecommendations
}
